import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getBlacklist } from '../api';
import { INormalizedBlacklist } from '../api/repositories/blacklist/blacklist.normalizer';
import {
  deleteBlacklist,
  postBlacklist,
} from '../api/repositories/blacklist/blacklist.sagas';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import {
  blacklistActions,
  EBlacklistActionType,
  TBlacklistAction,
} from './actions';

export function* getBlacklistSaga() {
  if (!(yield* checkHasCompletedProfile())) return;

  const response: INormalizedBlacklist = yield call(getBlacklist);

  yield put(blacklistActions.getBlacklistSuccess(response));
}

export function* postBlacklistSaga(
  action: ActionsOfType<TBlacklistAction, EBlacklistActionType.POST>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  yield call(postBlacklist, action.payload.receiverId);
  yield put(blacklistActions.postBlacklistSuccess(action.payload.receiverId));
}

export function* deleteBlacklistSaga(
  action: ActionsOfType<TBlacklistAction, EBlacklistActionType.DELETE>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  yield call(deleteBlacklist, action.payload.receiverId);
  yield put(blacklistActions.deleteBlacklistSuccess(action.payload.receiverId));
}

export function* blacklistRootSaga() {
  yield all([
    takeLatest(
      EBlacklistActionType.GET,
      handleAsyncStatus(getBlacklistSaga, EAsyncEventTypes.GET_BLACKLIST)
    ),
    takeLatest(
      EBlacklistActionType.POST,
      handleAsyncStatus(postBlacklistSaga, EAsyncEventTypes.BLOCK_USER)
    ),
    takeLatest(
      EBlacklistActionType.DELETE,
      handleAsyncStatus(deleteBlacklistSaga, EAsyncEventTypes.UNBLOCK_USER)
    ),
  ]);
}
